// extracted by mini-css-extract-plugin
export default {"header":"Header_header__rDvkD","main-image":"Header_main-image__e6TGP","logout":"Header_logout__WoGTl","flexbtn":"Header_flexbtn__urC9S"};